<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    v-dialogDrag
    :close-on-click-modal="false"
    title="添加资源"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="625px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
			<el-form-item label="资源类型：" prop="resourceType">
			  <el-select size="mini" clearable v-model="form.resourceType"
			   placeholder="请选择资源类型">
			  	<el-option v-for="item in resourceTypeList" :key="item.code" :label="item.name" :value="item.code"></el-option>
			  </el-select>
			</el-form-item>
				<el-form-item label="资源名称：" class="mr0" prop="resourceName">
				  <el-input
				    size="mini"
				    v-model.trim="form.resourceName"
				    placeholder="请输入资源名称"
				    clearable
				  ></el-input>
				</el-form-item>
        <el-form-item label="资源编号：" prop="resourceCode">
          <el-input
            size="mini"
            v-model.trim="form.resourceCode"
            placeholder="请输入资源编号"
            clearable
          ></el-input>
        </el-form-item>
				<el-form-item label="排序号：" prop="dorder" class="mr0">
				  <el-input
				    size="mini"
				    v-model.trim="form.dorder"
				    placeholder="请输入排序号"
				    clearable
				  ></el-input>
				</el-form-item>
				<el-form-item label="前端url：">
				  <el-input
				    size="mini"
				    v-model.trim="form.menuUrl"
				    placeholder="请输入前端url"
				    clearable
				  ></el-input>
				</el-form-item>
				<el-form-item label="后端url：" class="mr0">
				  <el-input
				    size="mini"
				    v-model.trim="form.resourceUrl"
				    placeholder="请输入后端url"
				    clearable
				  ></el-input>
				</el-form-item>
				<el-form-item label="图标：">
				  <el-input
				    size="mini"
				    v-model.trim="form.icon"
				    placeholder="请输入图标"
				    clearable
				  ></el-input>
				</el-form-item>
				<el-form-item label="在菜单栏显示：" label-width="98px" class="mr0 label-with-six-word">
					<el-select size="mini" v-model="form.menuShow" value-key="dictionaryCode">
						<el-option v-for="item in control" :key="item.dictionaryCode" :label="item.dictionaryValue" :value="item.dictionaryCode"></el-option>
					</el-select>
				</el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>

const getResourceTypeList = function(){}
export default {
  data() {
    return {
			control: [
				{ dictionaryValue: '是', dictionaryCode: 1},
				{ dictionaryValue: '否', dictionaryCode: 0}
			],
      form: {
        dorder: null,
				icon: '',
				menuShow: 1,
				menuUrl: '',
				resourceCode: '',
				resourceName: '',
				resourceType: '',
				resourceUrl: '',
				parentId: -1
      },
      rules: {
        resourceType: [
          {
            required: true,
            message: '请输入资源类型',
            trigger: 'blur'
          }
        ],
				resourceName: [
				  {
				    required: true,
				    message: '请输入资源名称',
				    trigger: 'blur'
				  }
				],
				resourceCode: [
				  {
				    required: true,
				    message: '请输入资源编号',
				    trigger: 'blur'
				  }
				],
				dorder: [
				  {
				    required: true,
				    message: '请输入排序号',
				    trigger: 'blur'
				  }
				],
				menuUrl: [
				  {
				    required: true,
				    message: '请输入前端url',
				    trigger: 'blur'
				  }
				],
				resourceUrl: [
				  {
				    required: true,
				    message: '请输入后端url',
				    trigger: 'blur'
				  }
				],
      },
			resourceTypeList: []
    }
  },
	props: {
		detail: {
			type: Object,
			required: true
		}
	},
  created() {
    this.getResourceTypeList()
		this.form = { ...this.detail }
		this.form.resourceType = this.detail.resourceType ? this.detail.resourceType.code : null
  },
  methods: {
		async getResourceTypeList() {
			const res = await getResourceTypeList()
			if (res.code === 200) {
				this.resourceTypeList = res.data
			}
		},
    handleBeforeClose(done) {
      this.$emit('cancel')
      done()
    },
    handleCancel() {
      this.$emit('cancel')
    },
    async handleConfirm() {
      this.$emit('cancel')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/UserManagement/components/CheckUser.vue